import { render, staticRenderFns } from "./AppointmentConfig.vue?vue&type=template&id=44706238"
import script from "./AppointmentConfig.vue?vue&type=script&lang=js"
export * from "./AppointmentConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports